import { ForgeProjectIteration, ForgeProjectIterationMergeMeta } from "@supernova-studio/model";
import { z } from "zod";
import { DTOForgeArtifact } from "./artifact";
import { DTOForgeIterationMessage } from "./iteration-message";

export const DTOForgeProjectIterationMergeMeta = ForgeProjectIterationMergeMeta;

export const DTOForgeProjectIteration = ForgeProjectIteration.omit({
  artifacts: true,
  messages: true,
  mergeMeta: true,
}).extend({
  artifacts: DTOForgeArtifact.array(),
  messages: DTOForgeIterationMessage.array(),
  mergeMeta: DTOForgeProjectIterationMergeMeta.optional(),
});

export const DTOGetForgeProjectIterationResponse = z.object({
  iteration: DTOForgeProjectIteration.nullable(),
});

export const DTOCreateForgeProjectIteration = DTOForgeProjectIteration.omit({
  forgeProjectId: true,
  artifacts: true,
  messages: true,
  mergeMeta: true,
  createdAt: true,
});

export const DTOUpdateForgeProjectIteration = DTOCreateForgeProjectIteration.extend({ id: z.string() });

export const DTOCreateForgeProjectIterationResponse = z.object({
  iteration: DTOForgeProjectIteration,
});

export const DTOUpdateForgeProjectIterationResponse = z.object({
  iteration: DTOForgeProjectIteration.nullable(),
});

export const DTODeleteForgeProjectIterationResponse = z.object({
  ok: z.literal(true),
});

export const DTOForgeProjectIterationListResponse = z.object({ iterations: z.array(DTOForgeProjectIteration) });

export type DTOForgeProjectIterationMergeMeta = z.infer<typeof DTOForgeProjectIterationMergeMeta>;
export type DTOForgeProjectIteration = z.infer<typeof DTOForgeProjectIteration>;
export type DTOForgeProjectIterationListResponse = z.infer<typeof DTOForgeProjectIterationListResponse>;
export type DTOGetForgeProjectIterationResponse = z.infer<typeof DTOGetForgeProjectIterationResponse>;
export type DTOCreateForgeProjectIteration = z.infer<typeof DTOCreateForgeProjectIteration>;
export type DTOUpdateForgeProjectIteration = z.infer<typeof DTOUpdateForgeProjectIteration>;
export type DTOCreateForgeProjectIterationResponse = z.infer<typeof DTOCreateForgeProjectIterationResponse>;
export type DTOUpdateForgeProjectIterationResponse = z.infer<typeof DTOUpdateForgeProjectIterationResponse>;
export type DTODeleteForgeProjectIterationResponse = z.infer<typeof DTODeleteForgeProjectIterationResponse>;
